import { useEffect, useRef, useState } from 'react'
import downArrowIcon from '../../Assets/Images/svgs/downArrowIcon.svg'
import upArrowIcon from '../../Assets/Images/svgs/upArrowIcon.svg'
import CONSTANTS from '../../Constants'
import { getDateAndTime, getLineCount } from '../../Helpers/Util'
import styles from './Notification.module.scss'

const Notification = (props: any) => {
  const { isRead, description, title, datetime } = props

  const ref = useRef<HTMLParagraphElement>(null)
  const [isEllipsis, setIsEllipsis] = useState(false)
  const [showMore, setShowMore] = useState(false)

  useEffect(() => {
    if (ref?.current) {
      const lines = getLineCount(ref.current)
      if (lines > 2) {
        setIsEllipsis(true)
      }
    }
  }, [])

  return (
    <div className={`${styles.notificationContainer} ${!isRead ? styles.active : ''}`}>
      <div className={styles.textWrapper}>
        <p className={styles.title}>{title}</p>
        <p
          ref={ref}
          className={`${styles.description} ${isEllipsis && !showMore ? styles.ellipsis : ''}`}
        >
          {description}
        </p>
        <div className={styles.actionWrapper}>
          <p className={styles.date}>
            {getDateAndTime(datetime)?.date} {getDateAndTime(datetime)?.time}
          </p>
          {isEllipsis && (
            <div
              className={styles.viewMore}
              onClick={(event: any) => {
                event.stopPropagation()
                event.preventDefault()
                setShowMore(!showMore)
              }}
            >
              {showMore ? (
                <p className={styles.less}>
                  {CONSTANTS.VIEW_LESS} <img alt='' src={upArrowIcon} />
                </p>
              ) : (
                <p>
                  {CONSTANTS.VIEW_MORE} <img alt='' src={downArrowIcon} />
                </p>
              )}
            </div>
          )}
        </div>
      </div>
      {!isRead && (
        <div className={styles.statusWrapper}>
          <span></span>
        </div>
      )}
    </div>
  )
}

export default Notification
